import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { IconName } from '@fortawesome/free-brands-svg-icons';
import { Footer } from './models/footer.model';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
@Component({
    imports: [FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    selector: 'remax-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  /**
   * Klartextname zum Flaggen-Code. Kommt aus Intl statt aus einer gepflegten Liste, damit
   * ein neuer Code im CMS nicht zu einem namenlosen Kästchen führt.
   */
  regionLabel(code: string): string {
    if (!code) {
      return '';
    }

    try {
      const display = new Intl.DisplayNames(['de'], { type: 'region' });
      return display.of(code.toUpperCase()) ?? code.toUpperCase();
    } catch {
      return code.toUpperCase();
    }
  }

  @Input() data: Footer;

  readonly cancellationLabel = 'Vertrag widerrufen';
  /**
   * Eigene, dauerhaft stabile Adresse — löst die frühere onOffice-Formular-URL ab,
   * die weder absicherbar noch änderbar war, ohne bereits versendete Links zu brechen.
   */
  readonly cancellationUrl = '/widerruf/';
  /** Alt-URL, damit im CMS gepflegte Links auf das onOffice-Formular weiter erkannt werden. */
  private readonly legacyCancellationUrl =
    'https://crm.onoffice.de/smart/app/smart/cancelation/WebCancellationForm/AppWebCancellationFormView.php';

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getIcon(icon: IconName, iconClass: string): string[] {
    return [iconClass, icon];
  }

  hasCancellationLink(): boolean {
    return (
      this.data?.navigation?.some((link) => {
        const label = link?.fields?.label?.toLowerCase() ?? '';
        const url = link?.fields?.url ?? '';
        return (
          url === this.cancellationUrl ||
          url.startsWith(this.legacyCancellationUrl) ||
          label.includes('widerruf')
        );
      }) ?? false
    );
  }

  /**
   * Leitet im CMS gepflegte Links auf das alte onOffice-Widerrufsformular auf die
   * eigene Seite um.
   *
   * Sicherheitsnetz: der Contentful-Eintrag sollte ebenfalls korrigiert werden — bis
   * dahin darf die öffentlich verlinkte Adresse nicht mehr auf das ungeschützte
   * Fremdformular zeigen, das die Spam-Welle im Service-Postfach ausgelöst hat.
   */
  resolveLinkUrl(url: string): string {
    return url?.startsWith(this.legacyCancellationUrl) ? this.cancellationUrl : url;
  }

  getLinkTarget(url: string): '_blank' | null {
    return this.isExternalUrl(this.resolveLinkUrl(url)) ? '_blank' : null;
  }

  getLinkRel(url: string): 'noopener noreferrer' | null {
    return this.isExternalUrl(this.resolveLinkUrl(url)) ? 'noopener noreferrer' : null;
  }

  private isExternalUrl(url: string): boolean {
    return /^https?:\/\//.test(url);
  }
}
